import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import Filter from "../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../Assets/Images/CommanImages/Rarrowbar.png";
import DeleteIcon from "../../Assets/Images/CommanImages/table_cross_icon.png";
import ReplaceIcon from "../../Assets/Images/CommanImages/tabler_replace-filled.png";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import EyeLockIcon from "../../Assets/Images/CommanImages/eye-lock-icon.png";
import SelectedValuesDropdown from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../Config/Config";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import comment1 from "../../Assets/Images/CommanImages/Vector (5).png";
import comment2 from "../../Assets/Images/CommanImages/Vector (6).png";
import Flag from "../../Assets/Images/CommanImages/tabler_flag-3-filled.png";
import Flag2 from "../../Assets/Images/CommanImages/tabler_flag-3.png";
import Eye1 from "../../Assets/Images/CommanImages/mdi_eye-lock-open-outline (1).png";
import Eye2 from "../../Assets/Images/CommanImages/mdi_eye-lock-open-outline (2).png";
import Colors from "../../Constants/Colors";

const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  renderQuestionText,
  handleRemoveRow,
  selectedSections,
  setSectionWiseQuestions,
  selecteSectionTypeID,
  handleReplaceRow,
  renderQuestionTextTable,
  selectedSectionPerRow,
  setSelectedSectionPerRow,
  isReadOnlyMode,
  onEyeClick = () => {}, // Add this new prop
  onCommentClick = () => {},
  questionComments = {},
}) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const columnDropdownRef = useRef(null);
  const [filters, setFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const generateSectionOptions = (selectedSections) => {
    return Array.from({ length: selectedSections }, (_, i) => {
      const label =
        selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i); // ✅ numeric or alphabetic
      return {
        id: label,
        label: label,
      };
    });
  };

  const options = generateSectionOptions(selectedSections || 1);
  useEffect(() => {
    if (data.length > 0 && selectedSections === 1) {
      const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

      const autoAssignDropdowns = {};
      const autoAssignSectionWise = { [defaultSectionLabel]: [] };

      data.forEach((row) => {
        const questionId = row[1];
        const questionText = row[2];

        autoAssignDropdowns[questionId] = defaultSectionLabel;
        autoAssignSectionWise[defaultSectionLabel].push({
          id: questionId,
          text: renderQuestionText(questionText),
        });
      });

      setSelectedSectionPerRow(autoAssignDropdowns);
      setSectionWiseQuestions?.(autoAssignSectionWise);
    } else if (selectedSections > 1) {
      // Clear previous auto-assignment if section count increased
      setSelectedSectionPerRow({});
      setSectionWiseQuestions({});
    }
  }, [data, selectedSections, selecteSectionTypeID]);

  useEffect(() => {
    if (headers.length > 0 && visibleColumns.length === 0) {
      const initialVisible = headers
        .slice(0, 6) // Get first 6 columns
        .filter((_, index) => index !== 4 && index !== 5); // Exclude index 4 and 5
      setVisibleColumns(initialVisible);
    }
  }, [headers, visibleColumns]);

  const handleColumnSelection = (column) => {
    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters }); // Persist selected filters
      setCurrentPage(1); // Reset to the first page
      setIsFiltersApplied(true); // Show Reset button
      setIsFilterVisible(false); // Hide the filter sidebar
    }
  };

  const handleResetFilter = () => {
    setFilters({}); // Clear current filter selections
    setAppliedFilters({}); // Clear applied filters
    setAverageRunTime(""); // Reset any other state if required
    setIsFiltersApplied(false); // Deactivate the Reset button
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;

    // Apply appliedFilters
    const matchesFilters = Object.entries(appliedFilters).every(
      ([key, value]) => {
        const colIndex = headers.indexOf(key);
        return value ? row[colIndex] === value : true;
      }
    );

    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {" "}
            {i}{" "}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            1{" "}
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            {" "}
            ...{" "}
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            {totalPages}{" "}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            1{" "}
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
      }
    }
    return pages;
  };
  const [columnWidth, setColumnWidth] = useState();
  const columnRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (isResizing.current) {
      const newWidth = Math.max(
        100,
        event.clientX - columnRef.current.offsetLeft
      );
      setColumnWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {headers
                  .filter((_, index) => index !== 4 && index !== 5) // Skip index 4 and 5
                  .map((column, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleColumnSelection(column);
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`column-${index}`}
                        name="columnSelection"
                        value={column}
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        readOnly
                      />
                      <label htmlFor={`column-${index}`}>{column}</label>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections-selected-ques-list">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className={`Heading-tc resizable-header ${
                        index === 1 ? "resizable-header" : ""
                      }`}
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                          marginLeft: index === 0 ? "130px" : "",
                        }}
                      >
                        {heading}
                        {index === 2 && (
                          <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                          ></div>
                        )}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* {paginatedData.map((row, rowIndex) => ( */}
                {paginatedData.map((row, rowIndex) => {
                  const questionId = row[1];
                  const questionText = row[2];
                  return (
                    <tr
                      key={rowIndex}
                      className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                    >
                      {visibleColumns.map((column, cellIndex) => (
                        <td
                          key={cellIndex}
                          style={{
                            width:
                              cellIndex === 3 ? `${columnWidth}px` : "100px",

                            textAlign: "left",
                            color: "#6A6A6A",
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: `${columnWidth}px`,
                          }}
                        >
                          {cellIndex === 0 ? ( // Ensure link only appears once
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                className="flag-container-ques-bank-dash"
                                style={{
                                  // width: "320px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "50px", // Increased from 10px to 20px for more spacing
                                }}
                              >
                                {/* Comment Image */}
                                <img
                                  src={
                                    questionComments &&
                                    questionComments[questionId]
                                      ? comment1
                                      : comment2
                                  }
                                  alt="comment"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                    marginLeft: "20px",
                                  }}
                                  onClick={() => onCommentClick(questionId)}
                                />

                                {/* Eye Image */}
                                <img
                                  src={Eye1}
                                  alt="eye"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => onEyeClick(questionId)} // Add this onClick handler
                                />
                              </div>

                              <Link style={{ color: "#337ab7" }}>
                                <span
                                  className="truncated-text"
                                  title={row[headers.indexOf(column)]}
                                >
                                  {" "}
                                  {headers.indexOf(column) === 2
                                    ? renderQuestionTextTable(
                                        row[headers.indexOf(column)]
                                      )
                                    : row[headers.indexOf(column)]}{" "}
                                </span>
                              </Link>
                            </div>
                          ) : (
                            <span className="truncated-text-2-RQP">
                              {" "}
                              {headers.indexOf(column) === 2
                                ? renderQuestionTextTable(
                                    row[headers.indexOf(column)]
                                  )
                                : row[headers.indexOf(column)]}{" "}
                            </span>
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              {" "}
              <img src={leftArrow} alt="" />{" "}
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {" "}
              {"<"}
            </button>{" "}
            {renderPagination()}{" "}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {" "}
              {">"}{" "}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              {" "}
              <img src={rightArrow} alt="" />{" "}
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn"
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              {" "}
              <p>X</p>{" "}
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              {isFiltersApplied && (
                <button
                  className="reset-btn-question-review-dash"
                  onClick={handleResetFilter}
                >
                  {" "}
                  RESET{" "}
                </button>
              )}
              <button
                className="apply-btn-question-review-dash"
                onClick={handleApplyFilter}
              >
                {" "}
                APPLY{" "}
              </button>
            </div>
            <div className="filter-options-container">
              {headers
                .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
                .map((header, filteredIndex) => {
                  const originalIndex =
                    filteredIndex === 0
                      ? 0
                      : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0);
                  let uniqueOptions = [
                    ...new Set(
                      data
                        .map((row) => row[originalIndex])
                        .filter((option) => option)
                    ),
                  ];
                  if (originalIndex === 0 || originalIndex === 6) {
                    uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  }
                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [header]: selectedOption,
                        }));
                      }}
                      options={uniqueOptions.map((value) => ({
                        label: value,
                        id: value,
                      }))}
                      selected={filters[header] || ""}
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const SectionWiseTableRenderer = ({
  sectionWiseReportData,
  availableSections,
  headers,
  renderQuestionText,
  handleRemoveRow,
  selectedSections,
  setSectionWiseQuestions,
  selecteSectionTypeID,
  handleReplaceRow,
  renderQuestionTextTable,
  selectedSectionPerRow,
  setSelectedSectionPerRow,
  isReadOnlyMode,
  onEyeClick,
  onCommentClick,
  questionComments,
  sectionInstructions, // NEW
}) => {
  return (
    <div className="section-wise-tables-container">
      {availableSections.map((sectionName) => {
        const instruction = sectionInstructions?.[sectionName] || "";

        return (
          <div
            key={`section-${sectionName}`}
            className="section-table-wrapper"
            style={{ marginBottom: 40 }}
          >
            <div
              className="section-header"
              style={{ paddingTop: 10, marginBottom: 10 }}
            >
              <div
                style={{
                  color: Colors.color1,
                  fontSize: 16,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <p style={{ fontWeight: "bold", margin: 0 }}>
                  Section {sectionName}
                </p>
                <span>
                  ({sectionWiseReportData[sectionName]?.length || 0} Questions)
                </span>
              </div>

              {/* Instruction: after section name, before search */}
              {instruction ? (
                <div
                  style={{
                    marginTop: 4,
                    color: "#6A6A6A",
                    fontSize: 13,
                    lineHeight: "18px",
                    maxWidth: "80vw",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={instruction}
                >
                  {instruction}
                </div>
              ) : null}
            </div>

            {/* TableComponent contains the search bar, so instruction appears above it */}
            <div className="section-table-content">
              <TableComponent
                key={`table-${sectionName}`}
                headers={headers}
                data={sectionWiseReportData[sectionName]}
                searchPlaceholder={`Filter • Section ${sectionName} Questions...`}
                renderQuestionText={renderQuestionText}
                handleRemoveRow={handleRemoveRow}
                selectedSections={selectedSections}
                setSectionWiseQuestions={setSectionWiseQuestions}
                selecteSectionTypeID={selecteSectionTypeID}
                handleReplaceRow={handleReplaceRow}
                renderQuestionTextTable={renderQuestionTextTable}
                selectedSectionPerRow={selectedSectionPerRow}
                setSelectedSectionPerRow={setSelectedSectionPerRow}
                isReadOnlyMode={isReadOnlyMode}
                onEyeClick={onEyeClick}
                onCommentClick={onCommentClick}
                questionComments={questionComments}
                sectionName={sectionName}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

const TableForCommentReviewQuestionPaper = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  selectedSections,
  setQuestionIds,
  activeSubjectId,
  setSectionWiseQuestions,
  selecteSectionTypeID,
  // tableQuestions,
  allQuesList,
  draftData,
  isReadOnlyMode,
  setDifficultyCount,
  version,

  onEyeClick = { onEyeClick }, // Pass the handler down

  onCommentClick = () => {},
  questionComments = {},

  sectionInstructions,
}) => {
  // Add this state to store section-wise data
  const [sectionWiseReportData, setSectionWiseReportData] = useState({});
  const [availableSections, setAvailableSections] = useState([]);
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
  const [draftLoaded, setDraftLoaded] = useState(false);

  const renderQuestionTextTable = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2-RQP">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2-RQP">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  useEffect(() => {
    const difficultyIndex = headers.findIndex((h) =>
      h.toLowerCase().includes("difficulty level")
    );

    const difficultyCount = { easy: 0, medium: 0, tough: 0 };

    if (reportDashboardData.length && draftLoaded) {
      reportDashboardData.forEach((row) => {
        const diff = row[difficultyIndex]?.toLowerCase();
        if (["easy", "medium", "tough"].includes(diff)) {
          difficultyCount[diff]++;
        }
      });
    }
    setDifficultyCount?.(difficultyCount);
  }, [reportDashboardData, headers, draftLoaded, activeSubjectId]);

  const quesTypeMapping = {
    "Single Correct MCQ": 1,
    "Multi Correct MCQ": 2,
    "Fill in the blanks": 3,
    "True/False": 4,
  };

  // Additional function to fetch selected questions based on activeSubjectId and draftData(SHASHI ON FRIDAY 30/05 2025)
  const fetchSelectedQuestions = async () => {
    const subjectWiseSelected = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const deletedRowMap = JSON.parse(
      localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
    );

    const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

    const draftSubjectQuestionsRaw =
      draftData?.subjects?.find(
        (subject) => subject.subject_id === activeSubjectId
      )?.questions || [];

    const draftSubjectQuestions = draftSubjectQuestionsRaw.filter(
      (q) => q.status === 1
    );
    const draftSubjectDeletedQuestions = draftSubjectQuestionsRaw.filter(
      (q) => q.status === 2
    );

    const draftSubjectIds = draftSubjectQuestions.map(
      (q) => q.parse_ques_set_question_id
    );
    const deletedDraftIds = draftSubjectDeletedQuestions.map(
      (q) => q.parse_ques_set_question_id
    );

    // Merge and deduplicate
    const mergedIds = Array.from(
      new Set([...localSubjectIds, ...draftSubjectIds])
    );

    // ✅ Remove deleted IDs
    const deletedIds = deletedRowMap[activeSubjectId] || [];
    const finalIds = mergedIds.filter((id) => !deletedIds.includes(id));

    if (finalIds.length === 0) {
      setReportDashboardData([]);
      setHeaders([]);
      return;
    }

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-questions-by-ids`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("other")}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(finalIds),
        }
      );

      const result = await response.json();
      const tableData = result?.data?.table_data || [];

      if (tableData.length > 1) {
        const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
        const rows = tableData.slice(1);
        setHeaders(["", ...headers]);
        // setReportDashboardData(rows.map((row) => ["", ...row]));

        // Create question ID to section mapping from draft data
        const questionToSectionMap = {};
        draftSubjectQuestions.forEach((q) => {
          questionToSectionMap[q.parse_ques_set_question_id] = q.section_name;
        });

        // Group questions by section
        const sectionGroups = {};
        const orderedRows = finalIds
          .map((id) => {
            const row = rows.find((r) => r[0] === id);
            if (row) {
              const sectionName = questionToSectionMap[id] || "A"; // Default to A if no section
              if (!sectionGroups[sectionName]) {
                sectionGroups[sectionName] = [];
              }
              sectionGroups[sectionName].push(["", ...row]);
              return row;
            }
            return null;
          })
          .filter((row) => row);

        // Set the section-wise data
        setSectionWiseReportData(sectionGroups);

        // Get available sections and sort them
        const sections = Object.keys(sectionGroups).sort();
        setAvailableSections(sections);

        // Keep the original reportDashboardData for backward compatibility
        setReportDashboardData(orderedRows.map((row) => ["", ...row]));
        // Ensure table rows follow the order of `finalIds`
        const idToRowMap = new Map();
        rows.forEach((row) => {
          const quesId = row[0]; // assuming 0 is Question ID (since headers have ["Section", ...])
          idToRowMap.set(quesId, row);
        });

        // const orderedRows = finalIds
        //   .map((id) => idToRowMap.get(id))
        //   .filter((row) => row); // skip if not found
        // setReportDashboardData(orderedRows.map((row) => ["", ...row])); // add empty section as first column

        // ✅ Auto-assign default section (A/1) when selecting questions for the first time if only one section exists
        if (selectedSections === 1) {
          const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";
          const newSectionMap = {};

          orderedRows.forEach((row) => {
            const questionId = row[0]; // before "Section" column
            newSectionMap[questionId] = defaultSection;
          });

          setSelectedSectionPerRow(newSectionMap);

          // Also build sectionWiseQuestions
          const sectionQuesMap = {
            [defaultSection]: orderedRows.map((row) => ({
              id: row[0],
              text: renderQuestionTextTable(row[2]),
            })),
          };
          setSectionWiseQuestions(sectionQuesMap);
        }

        const quesTypeMapPerSubject = {}; // New variable
        const questionTypeIndex = headers.findIndex((h) =>
          h.toLowerCase().includes("question type")
        );
        if (questionTypeIndex !== -1) {
          rows.forEach((row) => {
            const quesId = row[0]; // First column is Question ID (after Section)
            const quesTypeText = row[questionTypeIndex];
            const quesTypeId = quesTypeMapping[quesTypeText] || null;

            if (quesTypeId !== null) {
              quesTypeMapPerSubject[quesId] = quesTypeId;
            }
          });

          // ✅ Save as a new key in localStorage
          const existingTypeMap = JSON.parse(
            localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
          );
          localStorage.setItem(
            "subjectWiseQuesTypeIds",
            JSON.stringify({
              ...existingTypeMap,
              [activeSubjectId]: quesTypeMapPerSubject,
            })
          );
        }

        // ✅ Update localStorage: merge both
        const existing = JSON.parse(
          localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
        );
        localStorage.setItem(
          "subjectWiseSelectedRowIds",
          JSON.stringify({
            ...existing,
            [activeSubjectId]: finalIds,
          })
        );

        const existingDeleted = JSON.parse(
          localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
        );
        const currentSelected =
          JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
            activeSubjectId
          ] || [];

        const mergedDeletedIds = deletedDraftIds.filter(
          (id) => !currentSelected.includes(id)
        ); // ✅ do not save as deleted if user already reselected

        localStorage.setItem(
          "subjectWiseDeletedRowIds",
          JSON.stringify({
            ...existingDeleted,
            [activeSubjectId]: mergedDeletedIds,
          })
        );
        setDraftLoaded(true);
      }
    } catch (error) {
      console.error("Failed to fetch selected questions:", error);
    }
  };

  useEffect(() => {
    fetchSelectedQuestions();
  }, [activeSubjectId, draftData, version]);

  // Save selectedSectionPerRow to localStorage every time it updates
  useEffect(() => {
    if (
      !selectedSectionPerRow ||
      Object.keys(selectedSectionPerRow).length === 0
    )
      return;

    const existingMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    localStorage.setItem(
      "subjectWiseSectionMap",
      JSON.stringify({
        ...existingMap,
        [activeSubjectId]: selectedSectionPerRow,
      })
    );
  }, [selectedSectionPerRow, activeSubjectId]);

  // Restore selectedSectionPerRow and sectionWiseQuestions from localStorage
  useEffect(() => {
    const savedMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    const subjectMap = savedMap[activeSubjectId] || {};

    setSelectedSectionPerRow(subjectMap); // 🟢 restore dropdowns

    const newSectionWise = {};
    reportDashboardData.forEach((row) => {
      const quesId = row[1];
      const section = subjectMap[quesId];
      if (section) {
        if (!newSectionWise[section]) newSectionWise[section] = [];
        newSectionWise[section].push({
          id: quesId,
          text: renderQuestionTextTable(row[2]),
        });
      }
    });

    setSectionWiseQuestions(newSectionWise); // 🟢 restore section mapping
  }, [reportDashboardData, draftLoaded, activeSubjectId]);

  useEffect(() => {
    if (!reportDashboardData.length || !draftLoaded) return;

    const subject = draftData?.subjects?.find(
      (s) => s.subject_id === activeSubjectId
    );
    const dropdownMap = {};

    subject?.questions?.forEach((q) => {
      if (q.status === 1 && q.section_name) {
        const quesId = q.parse_ques_set_question_id;
        dropdownMap[quesId] = q.section_name;
      }
    });

    // 🧠 Merge draft (dropdownMap) + localStorage map
    const savedMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    const savedSubjectMap = savedMap[activeSubjectId] || {};

    const mergedMap = {
      ...dropdownMap, // from draft
      ...savedSubjectMap, // from previously saved manual changes
    };

    setSelectedSectionPerRow(mergedMap);

    // 🧠 Auto-assign section if none exists and only one section add this logic on Monday 14/07/2025
    const finalMap = { ...mergedMap };
    const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";

    if (selectedSections === 1) {
      reportDashboardData.forEach((row) => {
        const quesId = row[1];
        if (!finalMap[quesId]) {
          finalMap[quesId] = defaultSection;
        }
      });
    }

    setSelectedSectionPerRow(finalMap);

    // 💾 Save merged version back
    localStorage.setItem(
      "subjectWiseSectionMap",
      JSON.stringify({
        ...savedMap,
        [activeSubjectId]: mergedMap,
      })
    );

    // 🛠 Build sectionWiseQuestions from merged map
    const sectionMap = {};
    reportDashboardData.forEach((row) => {
      const quesId = row[1];
      const section = mergedMap[quesId];
      if (section) {
        if (!sectionMap[section]) sectionMap[section] = [];
        sectionMap[section].push({
          id: quesId,
          text: renderQuestionTextTable(row[2]),
        });
      }
    });

    setSectionWiseQuestions(sectionMap);
  }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

  const handleRemoveRow = (rowToDelete) => {
    const questionId = rowToDelete[1];
    // Remove from UI
    const updatedData = reportDashboardData.filter(
      (row) => row[1] !== questionId
    );
    setReportDashboardData(updatedData);

    // ✅ Remove from subjectWiseSelectedRowIds
    const selectedMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const updatedSelected = (selectedMap[activeSubjectId] || []).filter(
      (id) => id !== questionId
    );
    localStorage.setItem(
      "subjectWiseSelectedRowIds",
      JSON.stringify({
        ...selectedMap,
        [activeSubjectId]: updatedSelected,
      })
    );

    // ✅ Add to subjectWiseDeletedRowIds
    const deletedMap = JSON.parse(
      localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
    );
    const updatedDeleted = Array.from(
      new Set([...(deletedMap[activeSubjectId] || []), questionId])
    );
    localStorage.setItem(
      "subjectWiseDeletedRowIds",
      JSON.stringify({
        ...deletedMap,
        [activeSubjectId]: updatedDeleted,
      })
    );

    // ✅ Update difficulty count
    const difficultyIndex = headers.findIndex((h) =>
      h.toLowerCase().includes("difficulty level")
    );
    const diff = rowToDelete[difficultyIndex]?.toLowerCase();
    if (["easy", "medium", "tough"].includes(diff)) {
      setDifficultyCount((prev) => ({
        ...prev,
        [diff]: Math.max(0, (prev?.[diff] || 0) - 1),
      }));
    }
  };

  const handleReplaceRow = (rowToReplace) => {
    const questionIdIndex = 1; // in reportDashboardData
    const currentQuesId = rowToReplace[questionIdIndex];

    // ✅ Find this question in allQuesList to get correct Group ID
    const matchedRow = allQuesList.find((r) => r[0] === currentQuesId);

    if (!matchedRow) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              This question is missing from the current question set and cannot
              be replaced.
            </span>
          </div>
        </div>
      );
      return;
    }
    const groupIdIndexInAll =
      headers.findIndex((h) => h.toLowerCase().includes("group id")) - 1; // -1 because allQuesList doesn't have "Section"
    const currentGroupId = matchedRow[groupIdIndexInAll];

    console.log("✅ Correct Group ID from allQuesList:", currentGroupId);

    const selectedMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const selectedIds = selectedMap[activeSubjectId] || [];

    // ✅ Get same-group rows (excluding current and already selected)
    const sameGroupRows = allQuesList.filter(
      (r) =>
        r[groupIdIndexInAll] === currentGroupId &&
        r[0] !== currentQuesId &&
        !selectedIds.includes(r[0])
    );

    console.log(
      "🔄 Replacement candidates:",
      sameGroupRows.map((r) => r[0])
    );

    if (sameGroupRows.length === 0) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            {/* <span>No replacement found for the same Group ID.</span> */}
            <span>
              No available questions in the list to replace the selected
              question.
            </span>
          </div>
        </div>
      );
      return;
    }

    const replacementRow = sameGroupRows[0];

    // ✅ Replace row in reportDashboardData
    const updatedData = reportDashboardData.map((row) =>
      row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
    );
    setReportDashboardData(updatedData);

    // ✅ Update localStorage IDs
    const updatedIds = selectedIds
      .filter((id) => id !== currentQuesId)
      .concat(replacementRow[0]);
    localStorage.setItem(
      "subjectWiseSelectedRowIds",
      JSON.stringify({
        ...selectedMap,
        [activeSubjectId]: updatedIds,
      })
    );

    // ✅ Update question type map
    const quesTypeText =
      replacementRow[
        headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1
      ]; // -1 because we added "Section"
    const quesTypeId = quesTypeMapping[quesTypeText] || null;

    if (quesTypeId !== null) {
      const existingQuesTypeMap = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      const updatedQuesTypeMap = {
        ...(existingQuesTypeMap[activeSubjectId] || {}),
        [replacementRow[0]]: quesTypeId,
      };

      // Remove old ID
      delete updatedQuesTypeMap[currentQuesId];

      localStorage.setItem(
        "subjectWiseQuesTypeIds",
        JSON.stringify({
          ...existingQuesTypeMap,
          [activeSubjectId]: updatedQuesTypeMap,
        })
      );
    }
    console.log("✅ Replacement successful:", replacementRow[0]);
  };

  // Helper to get instruction for a given section label like "A", "B", "C"
  // const getSectionInstruction = useCallback(
  //   (secName) => {
  //     // Only use draftData to avoid undefined identifiers
  //     const fromDraft =
  //       (draftData?.subjects || [])
  //         .flatMap((s) => s?.sections || [])
  //         .find((s) => s?.sectionname === secName)
  //         ?.sectioninstruction?.trim?.() || "";
  //     return fromDraft;
  //   },
  //   [draftData]
  // );

  const getSectionInstruction = useCallback(
    (secName) => {
      if (!draftData?.subjects?.length || !activeSubjectId) return "";

      // Find the active subject’s draft block
      const subj = draftData.subjects.find(
        (s) => String(s?.subjectid) === String(activeSubjectId)
      );
      if (!subj?.sections?.length) return "";

      // Normalize names to string (A/B/C or "1"/"2" etc.)
      const wanted = String(secName).trim();

      const found = subj.sections.find(
        (s) => String(s?.sectionname).trim() === wanted
      );

      // Fallback: if naming is numeric in draft but table uses alphabetic (or vice versa)
      if (!found) {
        const isWantedAlphabetic = /^[A-Z]$/.test(wanted);
        const alt = isWantedAlphabetic
          ? String(wanted.charCodeAt(0) - 64) // "A"->1, "B"->2
          : String.fromCharCode(64 + Number(wanted)); // 1->"A"
        const altFound = subj.sections.find((s) => {
          const n = String(s?.sectionname).trim();
          return n === alt;
        });
        return altFound?.sectioninstruction?.trim?.() || "";
      }

      return found?.sectioninstruction?.trim?.() || "";
    },
    [draftData, activeSubjectId]
  );
  // console.log(draftData, "draftData");
  return (
    <div style={{ height: "auto", width: "100%" }}>
      <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
        {availableSections.length > 0 ? (
          <SectionWiseTableRenderer
            sectionWiseReportData={sectionWiseReportData}
            availableSections={availableSections}
            headers={headers}
            renderQuestionText={renderQuestionText}
            handleRemoveRow={handleRemoveRow}
            selectedSections={selectedSections}
            setSectionWiseQuestions={setSectionWiseQuestions}
            selecteSectionTypeID={selecteSectionTypeID}
            handleReplaceRow={handleReplaceRow}
            renderQuestionTextTable={renderQuestionTextTable}
            selectedSectionPerRow={selectedSectionPerRow}
            setSelectedSectionPerRow={setSelectedSectionPerRow}
            isReadOnlyMode={isReadOnlyMode}
            onEyeClick={onEyeClick}
            onCommentClick={onCommentClick}
            questionComments={questionComments}
            sectionInstructions={sectionInstructions}
          />
        ) : (
          // Fallback to single table if no sections are available
          <TableComponent
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Questions..."
            renderQuestionText={renderQuestionText}
            handleRemoveRow={handleRemoveRow}
            selectedSections={selectedSections}
            setSectionWiseQuestions={setSectionWiseQuestions}
            selecteSectionTypeID={selecteSectionTypeID}
            handleReplaceRow={handleReplaceRow}
            renderQuestionTextTable={renderQuestionTextTable}
            selectedSectionPerRow={selectedSectionPerRow}
            setSelectedSectionPerRow={setSelectedSectionPerRow}
            isReadOnlyMode={isReadOnlyMode}
            onEyeClick={onEyeClick}
            onCommentClick={onCommentClick}
            questionComments={questionComments}
          />
        )}
      </div>
    </div>
  );
};

export default TableForCommentReviewQuestionPaper;
